import React from "react";
import ScrollFadeComponent from "./ScrollFade";
import "./App.css";

import { useEffect } from "react";
import { db } from './firebase'; // firebase.js에서 내보낸 Firestore 인스턴스 가져오기
import { collection, addDoc } from 'firebase/firestore'; // Firestore 관련 함수 불러오기
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';

const sessionId = uuidv4(); // 고유한 세션 ID 생성
if (!sessionStorage.getItem('sessionId')) {
  sessionStorage.setItem('sessionId', sessionId);
}



const PriceInfo = () => {


  const contentList = [
    {
      type: "text",
      className: "text subtitle",
      content: "25,000원 이상 담았다면",
    },
    {
      type: "text",
      className: "text title",
      content: "장바구니 최저가 비교로 \n 커지는 절약",
    },
    {
      type: "image",
      src: "/images/basket_1.png",
      alt: "Example 1",
    },
    {
      type: "imageGroup",
      images: [
        {
          src: "/images/emart_mall.png",
          alt: "emart_mall",
        },
        {
          src: "/images/coupang_basket.png",
          alt: "coupang_basket",
        },
      ],
    },
  ];


  return (
    <div className="content-section">
      <div className="container content">
        {contentList
          .filter(content => content.type === "text")
          .map((content, index) => {
            const offset = 50 + index * 30;
            const delay = index * 20;
            return (
              <ScrollFadeComponent key={index} offset={offset} delay={delay}>
                <p className={content.className}>{content.content}</p>
              </ScrollFadeComponent>
            );
          })}
      </div>
      <div className="image-container">
        {contentList
          .filter(content => content.type !== "text")
          .map((content, index) => {
            const offset = 50 + (index + 2) * 50;
            const delay = (index + 2) * 150;
            return (
              <ScrollFadeComponent key={index} offset={offset} delay={delay}>
                {content.type === "image" ? (
                  <img src={content.src} alt={content.alt} style = {{width: "620px"}}/>
                ) : content.type === "imageGroup" ? (
                  <div className="image-group">
                    {content.images.map((image, imgIndex) => (
                      <img key={imgIndex} src={image.src} alt={image.alt} style = {{width: "310px"}}/>
                    ))}
                  </div>
                ) : null}
              </ScrollFadeComponent>
            );
          })}
      </div>
    </div>
  );
};

const ComparisonInfo = () => {
  const comparisonList = [
    {
      type: "text",
      className: "text subtitle",
      content: "멤버십이 없어도, 배송비가 있어도",
    },
    {
      type: "text",
      className: "text title",
      content: "더 저렴할 수 있는 \n 장바구니 추천",
    },
    {
      type: "image",
      src: "/images/min_price.png",
      alt: "Example 4",
    },
  ];

  return (
    <div className="content-section">
      {comparisonList.map((content, index) => {
        const offset = 50 + (index + 2) * 50;
        const delay = (index + 2) * 150;

        return (
          <ScrollFadeComponent key={index} offset={offset} delay={delay}>
            {content.type === "text" ? (
              <p className={content.className}>{content.content}</p>
            ) : (
              <img style={{marginTop: "30px", width: "660px"}} src={content.src} alt={content.alt} />
            )}
          </ScrollFadeComponent>
        );
      })}
    </div>
  );
};


const HowToUseInfo = () => {
  const comparisonList = [
    {
      type: "text",
      className: "text subtitle",
      content: "장바구니에 상품이 여러개 있어도",
    },
    {
      type: "text",
      className: "text title",
      content: "장바구니 화면 캡처면 \n 한번에 비교",
    },
    {
      type: "image",
      src: "/images/one_shot.png",
      alt: "basket_list",
    },
  ];

  return (
    <div className="content-section" style={{backgroundColor: "#f8f8f8"}}>
      {comparisonList.map((content, index) => {
        const offset = 300 + index * 50; // 인덱스에 따라 offset 자동 계산
        const delay = index * 150; // 인덱스에 따라 delay 자동 계산

        return (
          <ScrollFadeComponent key={index} offset={offset} delay={delay}>
            {content.type === "text" ? (
              <p className={content.className}>{content.content}</p>
            ) : (
              <img src={content.src} alt={content.alt} style={{marginTop: "30px", width: "660px"}} />
            )}
          </ScrollFadeComponent>
        );
      })}
    </div>
  );
};
const DeliveryInfo = () => {
  const textContents = [
    {
      type: "text",
      className: "text subtitle",
      content: "식품은 배송이 빨라야하니깐",
    },
    {
      type: "text",
      className: "text title",
      content: "당장 내일 오는\n 자체 배송만 추천",
    },
  ];

  const logoImages = [
    {
      src: "/images/homeplus_logo.png",
      alt: "homeplus",
    },
    {
      src: "/images/coupang_logo.png",
      alt: "coupang",
    },
    {
      src: "/images/emart_logo.png",
      alt: "emart",
    },
  ];

  return (
    <div className="container content" style={{backgroundColor: "#f8f8f8"}}>
    <div className="content-section">
      {textContents.map((content, index) => (
        <ScrollFadeComponent key={index} offset={300 + index * 50} delay={index * 300}>
          <p className={content.className}>{content.content}</p>
        </ScrollFadeComponent>
      ))}
      
      <ScrollFadeComponent offset={400} delay={300}>
        <div className="logo-container">
          {logoImages.map((logo, index) => (
            <img key={index} className="logo" src={logo.src} alt={logo.alt} />
          ))}
        </div>
      </ScrollFadeComponent>
    </div>
    </div>
  );
};

const ApplyBeta = () => {
  const comparisonList = [
    {
      type: "text",
      className: "text subtitle",
      content: "사전 신청",
    },
    {
      type: "text",
      className: "text title",
      content: "장바구니 최저가 비교로\n 계속 절약하기",
    },
  ];

  const reasonImages = [
    {
      src: "/images/reason_1.png",
      alt: "reason_1",
    },
    {
      src: "/images/reason_2.png",
      alt: "reason_2",
    },
    {
      src: "/images/reason_3.png",
      alt: "reason_3",
    },
  ];

  const [email, setEmail] = useState('');

  /* 버튼을 클릭하면, 이메일을 제출하는 함수 */
  async function handleClick() {
    const sessionId = sessionStorage.getItem('sessionId');

    if (!email) {
      alert('이메일을 입력해주세요.');
      return;
    }

    try {
      await addDoc(collection(db, "emails"), { email, sessionId, timestamp: new Date() });
      alert('사전 신청됐습니다. 감사합니다.');
      setEmail('');

      // 버튼 클릭 이벤트 추적
      await addDoc(collection(db, "userInteractions"), {
        sessionId,
        event: 'betaSignUp',
        email,
        timestamp: new Date(),
      });
    } catch (error) {
      console.error('Error adding email: ', error);
      alert('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  }

  return (
    <div className="content-section">
      {comparisonList.map((content, index) => {
        const offset = 300 + index * 50; // 인덱스에 따라 offset 자동 계산
        const delay = index * 100; // 인덱스에 따라 delay 자동 계산

        return (
          <ScrollFadeComponent key={index} offset={offset} delay={delay}>
            {content.type === "text" && (
              <p className={content.className}>{content.content}</p>
            )}
          </ScrollFadeComponent>
        );
      })}
      <ScrollFadeComponent offset={450} delay={400}>
        <div className="reason-images-container" style={{display: "flex", flexDirection: "column", justifyContent: "center", flexWrap: "wrap", gap: "20px", marginTop: "30px"}}>
          {reasonImages.map((image, index) => (
            <img 
              key={index} 
              src={image.src} 
              alt={image.alt} 
              style={{width: "620px", height: "auto"}}
            />
          ))}
        </div>
      </ScrollFadeComponent>


      <ScrollFadeComponent style={{display: "flex", flexDirection: "column", alignItems: "center"}} offset={400} delay={500}>   
      <input
        style={{width: "300px", height: "50px", padding: "10px", borderRadius: "12px", border: "0.8px solid #0077ed", marginTop: "50px", marginBottom: "20px", marginRight: "20px", boxSizing: "border-box"}}
        type="email"
        placeholder="이메일을 입력해주세요."
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button className="button" onClick={handleClick}>사전 신청</button>
      </ScrollFadeComponent>

    </div>
  );
};


const App = () => {

  useEffect(() => {
    // 세션 ID 생성 및 저장
    if (!sessionStorage.getItem('sessionId')) {
      const sessionId = uuidv4();
      sessionStorage.setItem('sessionId', sessionId);
    }

    // 페이지 유입 기록
    const logPageVisit = async () => {
      const sessionId = sessionStorage.getItem('sessionId');
      const timestamp = new Date();

      await addDoc(collection(db, "userSessions"), {
        sessionId,
        event: 'pageVisit',
        timestamp
      });
    };

    logPageVisit();
  }, []);

  useEffect(() => {
    // 스크롤 이벤트 추적
    const handleScroll = async () => {
      const scrollPosition = window.scrollY;
      const sessionId = sessionStorage.getItem('sessionId');

      // 예: 스크롤 위치가 500px 이상일 때 이벤트 기록
      if (scrollPosition >= 500) {
        await addDoc(collection(db, "userInteractions"), {
          sessionId,
          event: 'scroll',
          position: scrollPosition,
          timestamp: new Date(),
        });
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);




  return (
    <div className="container">
      <div className="container main">
        <span className="text main-title">장바구니<br />최저가 비교</span>
        <div className="overlay"></div>
        <img className="image" src="/images/background.jpg" alt="Example 1" />
      </div>
      {/* PriceInfo 및 ComparisonInfo 컴포넌트 호출 */}
      <PriceInfo />
      <HowToUseInfo />
      <ComparisonInfo />
      <DeliveryInfo />
      <ApplyBeta />
    </div>
     
  );
};

export default App;
